<template>
    <div class="menu-manage">
        <el-card class="filter-card">
            <div slot="header" class="clearfix">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="70px">
                <el-form-item label="系统">
                    <el-select size="small" v-model="formInline.companyId" placeholder="请选择系统" clearable>
                        <el-option
                            v-for="item in companyOptions"
                            :key="item.companyId"
                            :label="item.companyName"
                            :value="item.companyId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="菜单名称">
                    <el-input size="small" v-model="formInline.menuName" placeholder="请输入菜单名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" icon="el-icon-search" type="primary" @click="onSubmit">查 询</el-button>
                    <el-button size="small" icon="el-icon-plus" type="primary" @click="changeMenuInfo">新 增</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格列表 -->
        <el-card class="box-card" style="margin-top: 10px;">
            <el-table
                :data="tableData"
                style="width: 100%; margin-bottom: 20px;"
                row-key="menuId"
                :header-cell-style="{background: '#eef1f6', color: '#606266', fontWeight: 'bolder'}"
                tooltip-effect="dark"
                default-expand-all
                v-loading="loading"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                <el-table-column
                    label="序号"
                    width="55"
                    align="center"
                    type="index"
                ></el-table-column>
                <el-table-column
                    prop="menuName"
                    label="菜单名称"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="menuParentName"
                    label="父级菜单"
                    align="center">
                </el-table-column>
                <el-table-column
                    label="菜单类型"
                    align="center"
                >
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.menuLevel == 'M'">目录</el-tag>
                        <el-tag type="primary" v-if="scope.row.menuLevel == 'C'">菜单</el-tag>
                        <el-tag type="danger" v-if="scope.row.menuLevel == 'F'">按钮</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="component"
                    label="组件路径"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="路由名称"
                    align="center">
                </el-table-column>
                <!-- <el-table-column
                    prop="menuUrl"
                    label="URL"
                    align="center">
                </el-table-column> -->
                <el-table-column
                    label="操作"
                    width="180"
                >
                    <template slot-scope="scope">
                        <el-button type="info" size="mini" icon="el-icon-edit" @click="changeMenuInfo(scope.row)">编辑
                        </el-button>
                        <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteMenuItem(scope.row.menuId)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>

<script>
import { deleteMenuData, getMenuList } from '@/api/menuMange';
import { getSystemData } from "@/api/systemMange";
import { hasBtnPermission } from "@/utils";

export default {
    name: "MenuManage",
    data() {
        return {
            loading: false,
            title: '', // 新增/修改dialog标题
            changeVisible: false, // 新增/编辑dialog
            innerVisible: false, // 菜单选择dialog
            totalCount: 100,
            formInline: {
                companyId: '',
                menuName: '',
            },
            companyOptions: [],
            tableData: [],
            menuTreeList: [],
            defaultProps: {
                children: 'children',
                label: 'menuName'
            },
            searchSystemParams: {
                pageNo: 1,
                pageSize: 100,
                userCode: '',
                companyId: ''
            },
            i: 0
        }
    },
    activated() {
        this.getAllSystemInfo().then(() => {
            !this.formInline.companyId && (this.formInline.companyId = this.companyOptions[0].companyId)
            this.onSubmit()
        })
    },
    methods: {
        // 查询所有系统信息
        async getAllSystemInfo(){
            this.searchSystemParams.userCode = JSON.parse(window.sessionStorage.getItem('userInfo')).userId
            const res = await getSystemData(this.searchSystemParams);
            if(res.code == 200){
                this.companyOptions = res.data.list
            }else{
                this.$message.error(res.msg)
            }
        },
        // 查询按钮点击事件
        onSubmit() {
            if(!hasBtnPermission('sys:menu:list')){
                this.$message.warning('您暂无权限操作')
                return
            }
            if(!this.formInline.companyId){
                this.$message.warning('请先选择系统')
                return
            }
            this.getMenuTreeList()
        },
        // 确认查询
        async getMenuTreeList() {
            this.loading = true
            const res = await getMenuList(this.formInline);
            if (res.code === '200') {
                this.tableData = res.data
            } else {
                this.$message.error(res.msg)
            }
            this.loading = false
        },
        changeMenuInfo(item) {
            if(item.menuName){
                if(!hasBtnPermission('sys:menu:update')){
                    this.$message.warning('您暂无权限操作')
                    return
                }
                this.title = '编辑'
            }else{
                if(!hasBtnPermission('sys:menu:save')){
                    this.$message.warning('您暂无权限操作')
                    return
                }
                this.title = '新增'
            }
            this.$router.push({
                path: '/sys/menu/addMenu',
                query: { item: JSON.stringify(item) }
            })
        },
        // 删除菜单
        deleteMenuItem(menuId){
            if(!hasBtnPermission('sys:menu:delete')){
                this.$message.warning('您暂无权限操作')
                return
            }
            this.$confirm('确定删除该数据吗？', '提示')
                .then(_ => {
                    this.confirmDeleteMenuItem(menuId)
                })
                .catch(_ => {})
        },
        //  确定删除该数据
        async confirmDeleteMenuItem(menuId){
            const res = await deleteMenuData(menuId)
            if(res.code === '200'){
                this.$message.success('删除成功')
                this.getMenuTreeList()
            }else{
                this.$message.error(res.msg)
            }
        },
        handleClose() {
            this.changeVisible = false
        }
    }
}
</script>

<style scoped>
::v-deep .el-card__header {
    padding: 18px 10px;
}

::v-deep .el-card__body {
    padding: 20px 20px 0 20px;
}
</style>
<style scoped lang="scss">

</style>
